import type { MailFolder } from '@sunucupark/shared';

/** Folders whose unread mail the user cares about; drafts and sent never count. */
const COUNTED: ReadonlySet<string> = new Set(['inbox']);

/** Unread mail in the folders that matter, from the folder list the shell already loads. */
export function unreadOf(folders: readonly MailFolder[] | undefined): number {
  if (!folders) return 0;
  return folders.reduce((total, folder) => (folder.systemKind && COUNTED.has(folder.systemKind) ? total + folder.unreadCount : total), 0);
}
